//We can manipulate Gatsby LINK component here. Check for internal links, check for language etc.
import React from "react";
import { Link as GatsbyLink } from "gatsby";

const Link = ({
  children,
  to,
  newTab,
  activeClassName,
  partiallyActive,
  ...other
}) => {
  if (!to) return <>{children}</>;

  return (
    <GatsbyLink
      to={to}
      target={newTab ? "_blank" : ""}
      activeClassName={activeClassName}
      partiallyActive={partiallyActive}
      {...other}
    >
      {children}
    </GatsbyLink>
  );
};
export default Link;
